// @file Entrypoint for contact us page
import { currentUserPromise } from 'bits/current_user'
import { captureException, setScope } from 'bits/error_tracker'
import { setupVueApp } from 'bits/vue'
import ContactApp from 'vuecomponents/contact_app.vue'

currentUserPromise.then((user) => setScope({ userId: user.id })).catch(captureException)

setupVueApp({
  el: '#app',
  rootComponent: ContactApp,
  usePinia: true,
}).catch(captureException)
